// What a contact's action buttons DO, in one place, so the pop-up on Contacts, the full contact page
// and the CRM card can never lead to different places (Carla, live, 2026-10-21).
import { api } from '../../api/client';
import { loadStyleProfile } from '../../services/writingMemoryService';

// Through the app's own navigation (App.js applyNavigate): a page and one ?<entity>=<id>.
export function navigateTo(path) {
  window.dispatchEvent(new CustomEvent('aidey:navigate', { detail: path }));
}

// ── The full contact page's address: /contacts/<id>, with ?tab= for a tab other than Activity ──
export const CONTACTS_PATH = '/contacts';
export const CONTACT_TABS = ['activity', 'notes', 'meetings', 'invoices', 'documents', 'tasks', 'portal', 'intake'];
export function contactPagePath(id, tab) {
  const base = `${CONTACTS_PATH}/${encodeURIComponent(id)}`;
  return tab && tab !== 'activity' && CONTACT_TABS.includes(tab) ? `${base}?tab=${tab}` : base;
}
export function contactIdFromPath(pathname) {
  const m = /^\/contacts\/([^/?#]+)\/?$/.exec(String(pathname || ''));
  if (!m) return null;
  try { return decodeURIComponent(m[1]); } catch { return null; }
}
export function contactTabFromSearch(search) {
  try {
    const t = new URLSearchParams(search || '').get('tab');
    return CONTACT_TABS.includes(t) ? t : 'activity';
  } catch { return 'activity'; }
}
// Opens the full page: the address changes (so Back, reload and links work) and Contacts hears it.
export function openContactPage(id, tab) {
  const path = contactPagePath(id, tab);
  const elsewhere = !/^\/contacts(\/|$)/.test(window.location.pathname);
  try { window.history.pushState({}, '', path); } catch { /* an address that cannot be written */ }
  // From another page (the CRM card; or Contacts shown at "/" after a search), App switches to
  // Contacts, and rewrites the address to the path alone, so the tab is handed over here.
  if (elsewhere) { pendingTab = tab || null; navigateTo(path); }
  window.dispatchEvent(new Event('aidey:pathchange'));
}
let pendingTab = null;
export function takePendingTab() { const t = pendingTab; pendingTab = null; return t; }

// ── Book call: the owner's own booking link, in Aidey's composer ─────────────────────────────
// The link is the public booking page, /book/<bookingUsername> (routes/meetings.js /me/username).
// null when the owner has not set one up, or when it could not be read (said by the caller).
export async function ownBookingLink() {
  const d = await (await api('/api/meetings/me/username')).json();
  const username = d?.bookingUsername || null;
  return username ? `${window.location.origin}/book/${username}` : null;
}
// Her sign-off, as Aidey's drafts end (Aidey Backend/lib/emailDrafting): the one she chose in
// Writing style, else her first name. '' when it cannot be read: the draft is still hers to finish.
export async function ownSignOff() {
  try {
    const u = (await (await api('/api/users/me')).json())?.user || {};
    const chosen = String(loadStyleProfile(u).signOff || '').trim();
    return chosen || String(u.firstName || String(u.name || '').trim().split(/\s+/)[0] || '').trim();
  } catch { return ''; }
}
export function bookCallDraft(contact, link, signOff = '') {
  const first = String(contact?.name || '').trim().split(/\s+/)[0] || 'there';
  return {
    subject: 'Book a call',
    body: `Hi ${first},\n\nPick a time that suits you here: ${link}\n${signOff ? `\n${signOff}\n` : ''}`,
  };
}

// ── Invoice: the Invoices page, its form already addressed to this contact ───────────────────
export function newInvoiceFor(contactId) {
  navigateTo(`/invoices?invoice_new=${encodeURIComponent(contactId)}`);
}
